/* eslint-disable tailwindcss/no-custom-classname */
interface Props {
  onClick: (e) => void
}
export const Anonymous: React.FC<Props> = ({ onClick }) => {
  return (
    <div className="p-[2px] border-[3px] border-[#fd8637] border-solid">
      <div className="p-[10px] bg-[#f9f8f3] border border-[rgb(253,134,55)] border-solid">
        <div className="mb-[10px] text-xl leading-5">
          <span className="text-xl leading-5">
            要約全文を読む
            <wbr />
            には
            <wbr />
            <span className="text-xl leading-5 text-[#fd8637]">会員登録</span>・
            <span className="text-xl leading-5 text-[#fd8637]">ログイン</span>
            が必要です
          </span>
        </div>
        <div className="table mb-0 w-full max-w-full text-center">
          <div className="table-cell align-top">
            <a
              href="/user/register?af_via=summary"
              className="inline-block relative after:absolute after:top-[calc(50%-4px)] after:right-0 pr-[10px] hover:pb-0 mr-[5px] after:w-[9px] after:h-[9px] text-[#2dacdb] hover:text-[#23527c] no-underline hover:underline after:border-t-[2px] after:border-r-[2px] border-b border-transparent after:border-[#fe8d42] border-solid after:border-solid after:rotate-45 cursor-pointer after:content-['']"
              target="_blank"
              rel="noreferrer"
            >
              会員登録
            </a>
          </div>
          <div className="table-cell align-top">
            <span
              className="inline-block relative after:absolute after:top-[calc(50%-4px)] after:right-0 pr-[10px] hover:pb-0 mr-[5px] after:w-[9px] after:h-[9px] text-[#2dacdb] hover:text-[#23527c] no-underline hover:underline after:border-t-[2px] after:border-r-[2px] border-b border-transparent after:border-[#fe8d42] border-solid after:border-solid after:rotate-45 cursor-pointer after:content-['']"
              onClick={onClick}
            >
              ログイン
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
